/**
 * Mobile page layout tokens (Strava-inspired mobile web).
 * App `<main>` uses px-6 sm:px-8 lg:px-10 — pages that need a tighter gutter must
 * cancel that inset once ({@link APP_PAGE_BLEED_ROOT}) then apply {@link APP_PAGE_GUTTER}
 * on a single shell wrapper. Avoid nested horizontal px-* on child sections.
 */

/** Matches App.js `<main>` — for negative-margin bleed only. */
export const APP_MAIN_BLEED_X = '-mx-6 sm:-mx-8 lg:-mx-10';
export const APP_MAIN_BLEED_TOP = '-mt-4 sm:-mt-5';

/** Cancel App shell padding so the page owns one horizontal gutter. */
export const APP_PAGE_BLEED_ROOT = `${APP_MAIN_BLEED_X} ${APP_MAIN_BLEED_TOP}`;

/** Page shell — sole horizontal inset on phones (~12px). */
export const APP_PAGE_GUTTER = 'px-3 sm:px-4 md:px-6 lg:px-8';

/** @deprecated Use {@link APP_PAGE_GUTTER} — kept for competitive session imports. */
export const SESSION_PAGE_GUTTER = APP_PAGE_GUTTER;

/** Cards / panels inside the page — tighter touch targets on small screens. */
export const SESSION_PANEL_PADDING = 'p-2.5 sm:p-4';

/** White surface used by Manage sections (Match settings, Player Management roster). */
export const SESSION_PANEL_SURFACE = `rounded-lg border border-border-medium bg-surface ${SESSION_PANEL_PADDING}`;

/** Vertical stack between major blocks on the Courts tab. */
export const SESSION_SECTION_STACK = 'space-y-3 md:space-y-4';
